export class TableCellButton {

    id: string;
    icon: string;
    description: string;
    visible = true;
    burgerMenu = false;

    constructor (id: string, icon: string, description?: string, visible = true, burgerMenu = false) {
        this.id = id;
        this.icon = icon;
        this.description = description;
        this.visible = visible;
        this.burgerMenu = burgerMenu;
    }

}
